import {
  CAR_DATA_MASTER_GET_PAY_COMPANY_BEGIN,
  CAR_DATA_MASTER_GET_PAY_COMPANY_SUCCESS,
  CAR_DATA_MASTER_GET_PAY_COMPANY_FAILURE,
  CAR_DATA_MASTER_GET_PAY_COMPANY_DISMISS_ERROR
} from './constants'
import { BFFAgent } from 'BFFAgent';

export function getPayCompany() {
  return async (dispatch) => {
    dispatch({
      type: CAR_DATA_MASTER_GET_PAY_COMPANY_BEGIN,
    });

    try {
      const res = await BFFAgent.Payments.getPayCompany()
      if (res.companies.length > 0) {
        const payCompanies = res.companies.sort((a, b) => {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        })
        dispatch({
          type: CAR_DATA_MASTER_GET_PAY_COMPANY_SUCCESS,
          data: payCompanies
        })
      }
      else {
        dispatch({
          type: CAR_DATA_MASTER_GET_PAY_COMPANY_FAILURE,
          data: []
        })
        return
      }
    }
    catch (err) {
      dispatch({
        type: CAR_DATA_MASTER_GET_PAY_COMPANY_FAILURE,
        data: { error: err },
      });
      return err;
    }
  }
}

export function dismissGetPayCompanyError() {
  return {
    type: CAR_DATA_MASTER_GET_PAY_COMPANY_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CAR_DATA_MASTER_GET_PAY_COMPANY_BEGIN:
      return {
        ...state,
        getPagosPending: true,
        getPagosError: null,
      };

    case CAR_DATA_MASTER_GET_PAY_COMPANY_SUCCESS:
      return {
        ...state,
        getPagosPending: false,
        getPagosError: null,
        pagosListOrigin: action.data
      };

    case CAR_DATA_MASTER_GET_PAY_COMPANY_FAILURE:
      return {
        ...state,
        getPagosPending: false,
        getPagosError: action.data.error,
        pagosListOrigin: []
      };

    case CAR_DATA_MASTER_GET_PAY_COMPANY_DISMISS_ERROR:
      return {
        ...state,
        getPagosError: null,
      };

    default:
      return state;
  }
}
